/** @format */

import React from 'react';
import NumberFormat from 'react-number-format';
import withFieldEditHandler from './with_field_edit_handler';
import {handleChange} from 'frontier-form';

export default withFieldEditHandler(
    handleChange(({className = 'cart-field', style = {}, ...props}) => {
        return (
            <div className={className} style={style}>
                {props.title && <label className="cart-field-label">{props.title}</label>}
                <NumberFormat
                    onKeyUp={props.onKeyUp}
                    onBlur={props.onSave}
                    value={props.form.value || ''}
                    className="cart-field-input"
                    onChange={props.onInputChange.bind(this, 'form.value')}
                    displayType={props.isEditable ? 'input' : 'text'}
                    {...props.numberFormatProps}
                />
            </div>
        );
    })
);
